import { DispatchType, StoreAction } from "../reduxTypes";
import recuperarSenhaService from "../../services/recuperarSenha";
import { Error202, parseError } from "../../utils/http-helper";

export const RECUPERAR_SENHA__LIMPAR_DADOS = "RECUPERAR_SENHA__LIMPAR_DADOS";
export const RECUPERAR_SENHA__SET_DADOS = "RECUPERAR_SENHA__SET_DADOS";
export const RECUPERAR_SENHA__SET_DADOS_CONFIRMADOS =
  "RECUPERAR_SENHA__SET_DADOS_CONFIRMADOS";
export const RECUPERAR_SENHA__SET_EMAIL = "RECUPERAR_SENHA__SET_EMAIL";

function limparDados(): StoreAction {
  return {
    type: RECUPERAR_SENHA__LIMPAR_DADOS,
  };
}

function setDados(dados: Object): StoreAction {
  return {
    type: RECUPERAR_SENHA__SET_DADOS,
    payload: dados,
  };
}
function setEmail(email: Object): StoreAction {
  return {
    type: RECUPERAR_SENHA__SET_EMAIL,
    payload: email,
  };
}

function setDadosConfirmados(confirmado: boolean): StoreAction {
  return {
    type: RECUPERAR_SENHA__SET_DADOS_CONFIRMADOS,
    payload: confirmado,
  };
}

function confirmarDados(email: string, cpf: string, dataNascimento: string) {
  return function (dispatch: DispatchType) {
    return recuperarSenhaService
      .confirmarDados(cpf, email, dataNascimento)
      .then((resp) => {
        if (resp.data === null) {
          throw new Error202("Dados Inválidos!");
        }
        dispatch(setDadosConfirmados(!!resp.data));
        dispatch(setEmail(resp.data.email || resp.data.Email));
      })
      .catch((error) => {
        parseError(error, "Erro ao confirmar dados");
      });
  };
}

function recadastrarNovaSenha(
  email: string,
  cpf: string,
  dataNascimento: string,
  novaSenha: string,
  confNovaSenha: string,
  codigo: string,
  callback: () => void
) {
  return function (dispatch: DispatchType) {
    return recuperarSenhaService
      .recadastrarNovaSenha(
        email,
        cpf,
        dataNascimento,
        novaSenha,
        confNovaSenha,
        codigo
      )
      .then((resp) => {
        if (resp.data === null || resp.status === 202) {
          throw new Error202("Dados Inválidos!");
        }
        callback();
      })
      .catch((error) => {
        parseError(error, "Erro ao confirmar dados");
      })
      .finally(() => dispatch(limparDados()));
  };
}

const recuperarSenhaActions = {
  limparDados,
  setDados,
  confirmarDados,
  recastrarNovaSenha: recadastrarNovaSenha,
};

export default recuperarSenhaActions;
